import { useState } from "react";
import "./SearchBar.css";
import { SearchIcon } from "src/SharedComponents/Icons/Icons";

interface ISearchBarParams {
  onChange: (text: string) => void;
  value?: string;
  height?: string;
}

const SearchBar: React.FC<ISearchBarParams> = ({ onChange, value, height }) => {
  let val = value ? value : "";
  const [input, setInput] = useState<string>(val);
  return (
    <div className="input-wrapper w-100">
      <span className="search-icon">
        <SearchIcon />
      </span>
      <input
        className="search w-100"
        placeholder=""
        value={input}
        style={height ? { height } : undefined}
        onChange={(e) => {
          var inputVal = e.target.value;
          setInput(inputVal);
          onChange(inputVal);
        }}
      />
    </div>
  );
};

export default SearchBar;
